import { Component, OnInit } from '@angular/core';
import {NgbTabsetConfig} from '@ng-bootstrap/ng-bootstrap';
import { ClientesService } from 'src/app/services/clientes.service';
import { PaquetesService } from 'src/app/services/paquetes.service';
import { environment } from '../../../environments/environment';
import { NgbModal, NgbModalConfig } from "@ng-bootstrap/ng-bootstrap";
import { LoginService } from 'src/app/services/login.service';
import { ProductosService } from 'src/app/services/productos.service';
import { CatalogosService } from 'src/app/services/catalogos.service';

@Component({
  selector: 'app-perfil',
  templateUrl: './perfil.component.html',
  styleUrls: ['./perfil.component.scss'],
  providers: [NgbTabsetConfig] // add NgbTabsetConfig to the component providers
})
export class PerfilComponent implements OnInit {
  environment = environment.BASE_URL
  public preciosAnilloIds: number[] = [];
  public medidaAnillos: number[] = [];
  
  public boletos_adulto: number [] = [];
  public boletos_nino: number [] = [];

  respuestaMolduras: any;
  respuestaPlacas: any;
  respuestaPaquetes: any;
  respuestaDetallePaquete:any;
  respuestaAgregarPaqueteCliente:any;
  respuestaDedicatorias:any;
  respuestaProductos:any;
  respuestaPaqueteCliente:any;
  respuestaEliminarPaqueteCliente:any;
  respuestaAgregarProductoCliente:any;
  respuestaAgregar:any;
  respuestaAgregarPlaca:any;
  respuestaAgregarColor:any;
  respuestaEliminarPlaca:any;
  respuestaEliminarMoldura:any;
  respuestaAgregarMoldura:any;
  respuestaColores:any;
  respuestaEliminarColor:any;
  respuestaEliminarAnillo:any;
  respuestaSolicitado:any;
  respuestaGuardar:any;
  respuestaViajes:any;
  respuestaAgregarViaje:any;
  respuestaFiestas:any;
  respuestaAgregarBoletosAdulto:any;
  respuestaAnillos:any;
  respuestaAgregarAnilloCliente:any;
  respuestaPrecioAnillos:any;
  respuestaGet:any;
  anillos;
  viajes;
  solicitado;
  fiestas;
  precioAnillos;
  datosCliente;

  molduras;
  placas;
  paquetesToChoose;
  data;
  detallePaquete;
  paqueteid;
  nombrePaquete;
  descripcion;
  paqueteImagen;
  paqueteCliente;
  clienteid;
  colores;
  p
  boletos;
  productos;
  dedicatorias;
  dedicatoriaPersonalizada;
  fondosMarcos;
  respuestaFondosMolduras:any;
  active = 1;
  pagos = [
    {'fecha':'2020-03-10', 'monto':'750', 'forma_pago':'Efectivo', 'tipo_pago':'Cuadros'},
    {'fecha':'2020-04-10', 'monto':'750', 'forma_pago':'Efectivo', 'tipo_pago':'Cuadros'},
  ]

  total = 1500;

  constructor(config: NgbTabsetConfig, private _getMolduras: ClientesService, private _getPlacas: ClientesService, 
    private _getPaquetes: PaquetesService, private _getDetallePaquete: PaquetesService, private modalService: NgbModal,
    private _agregarPaqueteCliente: ClientesService, private _getPaqueteCliente:ClientesService, private _eliminarPaqueteCliente: ClientesService,
    private _agregarMoldura: ClientesService, private _agregarPlaca: ClientesService, private _agregarColor: ClientesService,
    private _eliminarPlaca: ClientesService, private _getColores:ClientesService, private _getSolicitado: ClientesService,
    private _eliminarMoldura: ClientesService, private _eliminarColorCliente: ClientesService, 
    private _getFiestas:ClientesService, private _agregarBoletosAdulto: ClientesService, private _getAnillos:ClientesService,
    private _solicitarPaquete: ClientesService, private _getViajes: ClientesService, private _agregarViaje:ClientesService,
    private _eliminarAnilloCliente: ClientesService, private _get:LoginService, private _agregarProductoCliente:ClientesService,
    private _agregarAnilloCliente:ClientesService, private _agregar:ClientesService, private _getProductos: ProductosService,
    private _getDedicatorias:ProductosService, private _getFondosMolduras:CatalogosService,
     ) { 
    config.justify = 'center';
    config.type = 'pills';
  }


  ngOnInit(): void {
    this.getDataCliente();
    this.getPaquetes();
    this.getMolduras();
    this.getPlacas();
    this.getFondosMarcos();
    
    this.getColores();
    this.getViajes();
    this.getFiestas();
    this.getAnillos();
    this.getPrecioAnillos();
    this.getProductos();
    this.getDedicatorias();

    this.boletos = {
      'adulto':'',
      'nino':'',
    }

    this.dedicatoriaPersonalizada = {
      texto: '',
      dirigido:'',
    }
  }

  getDataCliente(){
    console.log('entraaaaa');
    this._get.getDataCliente().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.datosCliente = this.respuestaGet.content;
          this.clienteid = this.datosCliente.id;
          this.getSolicitado(this.clienteid);
          this.getPaqueteCliente(this.clienteid);
          // alert(this.clienteid);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error))
  }

  getDedicatorias(){
    this._getDedicatorias.getDedicatorias().subscribe(
      data => {
        this.respuestaDedicatorias = data;
        if(this.respuestaDedicatorias.success){
          this.dedicatorias = this.respuestaDedicatorias.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  getProductos(){
    this._getProductos.getProductos().subscribe(
      data => {
        this.respuestaProductos = data;
        if(this.respuestaProductos.success){
          this.productos = this.respuestaProductos.content;
          console.log(this.productos);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  getColores(){
    this._getColores.getColores().subscribe(
      data => {
        this.respuestaColores = data;
        if(this.respuestaColores.success){
          this.colores = this.respuestaColores.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  getMolduras(){
    this._getMolduras.getMolduras().subscribe(
      data => {
        this.respuestaMolduras = data;
        if(this.respuestaMolduras.success){
          this.molduras = this.respuestaMolduras.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getPlacas(){
    this._getPlacas.getPlacas().subscribe(
      data => {
        this.respuestaPlacas = data;
        if(this.respuestaPlacas.success){
          this.placas = this.respuestaPlacas.content;
          console.log(this.placas);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getViajes(){
    this._getViajes.getViajes().subscribe(
      data => {
        this.respuestaViajes = data;
        if(this.respuestaViajes.success){
          this.viajes = this.respuestaViajes.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getPaquetes(){
    this._getPaquetes.getPaquetesCliente().subscribe(
      data => {
        this.respuestaPaquetes = data;
        if(this.respuestaPaquetes.success){
          this.paquetesToChoose = this.respuestaPaquetes.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  getFiestas(){
    this._getFiestas.getFiestas().subscribe(
      data => {
        this.respuestaFiestas = data;
        if(this.respuestaFiestas.success){
          this.fiestas = this.respuestaFiestas.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  getAnillos(){
    this._getAnillos.getAnillos().subscribe(
      data => {
        this.respuestaAnillos = data;
        if(this.respuestaAnillos.success){
          this.anillos = this.respuestaAnillos.content;
          this.inizializarPrecios();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  

  getPrecioAnillos(){
    this._getAnillos.getPrecioAnillos().subscribe(
      data => {
        this.respuestaPrecioAnillos = data;
        if(this.respuestaPrecioAnillos.success){
          this.precioAnillos = this.respuestaPrecioAnillos.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  inizializarPrecios(){
    for(let ianillo of this.anillos){
      this.preciosAnilloIds.push(0);
      this.medidaAnillos.push(0);
    }
  }

public selectAnillo(anilloid: number): void {
  var anilloPrecioSelected = "precioAnillo"+anilloid;
}

  getDetallePaquete(paquete){
    this.data = {
      'paquete':paquete
    }

    this._getDetallePaquete.getDetallePaquete(this.data).subscribe(
      data => {
        this.respuestaDetallePaquete = data;
        if(this.respuestaDetallePaquete.success){
          this.detallePaquete = this.respuestaDetallePaquete.content;
          this.paqueteid = paquete;
          this.nombrePaquete = this.detallePaquete[0].paquete;
          this.descripcion = this.detallePaquete[0].descripcion;
          if (this.detallePaquete[0].imagen.length == 0){
            this.paqueteImagen = '/uploads/paquete/auri.png';
          }else{
            this.paqueteImagen = this.detallePaquete[0].imagen;
          }
          document.getElementById('clickPaquete').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getSolicitado(cliente){
    this.data = {
      'usuario':cliente
    }

    this._getSolicitado.getSolicitado(this.data).subscribe(
      data => {
        this.respuestaSolicitado = data;
        if(this.respuestaSolicitado.success){
          this.solicitado = this.respuestaSolicitado.content.solicitado;
          // alert(this.solicitado);
          this.clienteid = cliente;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  getPaqueteCliente(cliente){
    this.data = {
      'cliente':cliente
    }

    this._getPaqueteCliente.getPaqueteCliente(this.data).subscribe(
      data => {
        this.respuestaPaqueteCliente = data;
        if(this.respuestaPaqueteCliente.success){
          this.paqueteCliente = this.respuestaPaqueteCliente.content;
          this.clienteid = cliente;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }


  agregarPaqueteCliente(paquete, cliente){
    this.data = {
      'paquete':paquete, 
      'cliente':cliente
  }

  this._agregarPaqueteCliente.agregarPaqueteCliente(this.data).subscribe(
    data => {
      this.respuestaAgregarPaqueteCliente = data;
      if(this.respuestaAgregarPaqueteCliente.success){
        this.dismissAll();
        this.getPaqueteCliente(cliente);
        window.location.reload();
      }else {
        alert('No se cargaron los datos');
      }
    }, error => console.error(error)
  )
  }


  eliminarPaqueteCliente(paquete, cliente){
    this.data = {
      'paqueteCliente':paquete
    }

    this._eliminarPaqueteCliente.eliminarPaqueteCliente(this.data).subscribe(
      data => {
        this.respuestaEliminarPaqueteCliente = data;
        if(this.respuestaEliminarPaqueteCliente.success){
          this.dismissAll();
          this.getPaqueteCliente(cliente);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  agregarPlaca(placa, cliente){
    this.data = {
        'placa':placa, 
        'usuario':cliente
    }

    this._agregarPlaca.agregarPlacaUsuario(this.data).subscribe(
      data => {
        this.respuestaAgregarPlaca = data;
        if(this.respuestaAgregarPlaca.success){
          this.dismissAll();
          this.getPaqueteCliente(cliente);
          window.location.reload();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  agregarProductoCliente(producto, cliente){
    this.data = {
        'producto':producto, 
        'cliente':cliente
    }

    this._agregarProductoCliente.agregarProductoCliente(this.data).subscribe(
      data => {
        this.respuestaAgregarProductoCliente = data;
        if(this.respuestaAgregarProductoCliente.success){
          this.dismissAll();
          window.location.reload();
          
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  agregarDedicatoriaCliente(nombre, texto, dirigido, cliente){
    this.data = {
        'nombre':nombre, 
        'texto':texto, 
        'dirigido':dirigido, 
        'cliente':cliente
    }

    this._agregar.agregarDedicatoriaCliente(this.data).subscribe(
      data => {
        this.respuestaAgregar = data;
        if(this.respuestaAgregar.success){
          this.dismissAll();
          window.location.reload();
          
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  agregarColor(color, cliente){
    this.data = {
      'color':color, 
      'cliente':cliente
  }

    this._agregarColor.agregarColorUsuario(this.data).subscribe(
      data => {
        this.respuestaAgregarColor = data;
        if(this.respuestaAgregarColor.success){
          this.dismissAll();
          this.getPaqueteCliente(cliente);
          window.location.reload();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  agregarMoldura(moldura, cliente){
    this.data = {
        'moldura':moldura, 
        'usuario':cliente
    }

    this._agregarMoldura.agregarMolduraUsuario(this.data).subscribe(
      data => {
        this.respuestaAgregarMoldura = data;
        if(this.respuestaAgregarMoldura.success){
          this.dismissAll();
          this.getPaqueteCliente(cliente);
          window.location.reload();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }


  agregarViaje(viaje, cliente){
    this.data = {
        'viaje':viaje, 
        'cliente':cliente
    }

    this._agregarViaje.agregarViajeCliente(this.data).subscribe(
      data => {
        this.respuestaAgregarViaje = data;
        if(this.respuestaAgregarViaje.success){
          this.dismissAll();
          this.getPaqueteCliente(cliente);
          window.location.reload();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  

  eliminarPlaca(placa, cliente){
    this.data = {
        'placa':placa
    }

    this._eliminarPlaca.eliminarPlaca(this.data).subscribe(
      data => {
        this.respuestaEliminarPlaca = data;
        if(this.respuestaEliminarPlaca.success){
          this.dismissAll();
          this.getPaqueteCliente(cliente);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  eliminarMoldura(moldura, cliente){
    console.log(moldura);
    this.data = {
        'moldura':moldura
    }

    this._eliminarMoldura.eliminarMoldura(this.data).subscribe(
      data => {
        this.respuestaEliminarMoldura = data;
        if(this.respuestaEliminarMoldura.success){
          this.dismissAll();
          this.getPaqueteCliente(cliente);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  eliminarColorCliente(color, cliente){
    this.data = {
      'color':color
    }

    this._eliminarColorCliente.eliminarColorUsuario(this.data).subscribe(
      data => {
        this.respuestaEliminarColor = data;
        if(this.respuestaEliminarColor.success){
          this.dismissAll();
          this.getPaqueteCliente(cliente);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  guardarPaquete(cliente){
    this.data = {
      'cliente':cliente
    }

    this._solicitarPaquete.solicitarPaquete(this.data).subscribe(
      data => {
        this.respuestaGuardar = data;
        if(this.respuestaGuardar.success){
          this.getPaqueteCliente(cliente);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  agregarBoletosAdulto(cliente, fiesta, i){
    this.data = {
      'boletos_adulto':this.boletos_adulto[i], 
      'cliente':cliente,
      'fiesta':fiesta
  }

  this._agregarBoletosAdulto.agregarBoletosAdulto(this.data).subscribe(
    data => {
      this.respuestaAgregarBoletosAdulto = data;
      if(this.respuestaAgregarBoletosAdulto.success){
        this.dismissAll();
        this.getPaqueteCliente(cliente);
        window.location.reload();
      }else {
        alert('No se cargaron los datos');
      }
    }, error => console.error(error)
  )
  }


  agregarBoletosNino(cliente, fiesta, i){
    this.data = {
      'boletos_nino':this.boletos_nino[i], 
      'cliente':cliente,
      'fiesta':fiesta
  }

  this._agregarBoletosAdulto.agregarBoletosNino(this.data).subscribe(
    data => {
      this.respuestaAgregarBoletosAdulto = data;
      if(this.respuestaAgregarBoletosAdulto.success){
        this.dismissAll();
        this.getPaqueteCliente(cliente);
        window.location.reload();
      }else {
        alert('No se cargaron los datos');
      }
    }, error => console.error(error)
  )
  }

  agregarAnilloCliente(anillo, cliente, precioAnilloId, medidaAnillo){
    this.data = {
      'cliente':cliente,
      'anillo':anillo,
      'precioAnillo': precioAnilloId,
      'medidaAnillo': medidaAnillo,
  }
  
    this._agregarAnilloCliente.agregarAnilloCliente(this.data).subscribe(
      data => {
        this.respuestaAgregarAnilloCliente = data;
        if(this.respuestaAgregarAnilloCliente.success){
          this.dismissAll();
          this.getPaqueteCliente(cliente);
          window.location.reload();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  getFondosMarcos(){
    this._getFondosMolduras.getFondosMolduras().subscribe(
      data => {
        this.respuestaFondosMolduras = data;
        if(this.respuestaFondosMolduras.success){
          this.fondosMarcos = this.respuestaFondosMolduras.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  agregarFondoMolduraCliente(fondoMoldura, cliente){
    this.data = {
        'fondo_moldura':fondoMoldura, 
        'usuario':cliente
    }

    this._agregarProductoCliente.agregarFondoMolduraCliente(this.data).subscribe(
      data => {
        this.respuestaAgregarProductoCliente = data;
        if(this.respuestaAgregarProductoCliente.success){
          window.location.reload();
          
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  eliminarAnilloCliente(anillo, cliente){
    this.data = {
      'anillo':anillo
    }

    this._eliminarAnilloCliente.eliminarAnilloCliente(this.data).subscribe(
      data => {
        this.respuestaEliminarAnillo= data;
        if(this.respuestaEliminarAnillo.success){
          this.dismissAll();
          this.getPaqueteCliente(cliente);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  
  openModal(modal) {
    this.modalService.open(modal, { size: 'lg' });
  }

  dismissAll() {
    this.modalService.dismissAll();
  }
}
